import React, { useState } from "react";
import AddEventModal from "../admin/AddEventModal.jsx";
import SmartEventsGen from "../admin/SmartEventsGen.jsx";
import Button from "../ui/Button.jsx";
import JsonEventsImporter from "../admin/JsonEventsImporter.jsx";
import AdminActions from "../admin/AdminActions.jsx";

export default function Admin() {
    const [activeTab, setActiveTab] = useState("addEvent");

    const tabs = [
        { id: "addEvent", label: "Add Event (Manual)" },
        { id: "aiEvents", label: "Add Event (AI)" },
        { id: "jsonEvents", label: "Add Event (Json)" },
        { id: "adminActions", label: "Admin Actions" },
        { id: "settings", label: "Site Settings" },
    ];

    return (
        <div className="absolute top-50 left-0 right-0 mx-auto w-full max-w-4xl p-4">
            <div className="bg-white shadow-md rounded-lg p-4">
                <h1 className="app-title text-3xl font-bold text-center mb-6">
                    Admin
                </h1>

                {/* Tabs */}
                <div className="flex justify-around mb-4 border-b">
                    {tabs.map((tab) => (
                        <Button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`font-medium transition ${
                                activeTab === tab.id
                                    ? "border-b-2 border-blue-500 text-blue-600 bg-yellow-100"
                                    : "text-gray-500 hover:text-blue-600 bg-yellow-100"
                            }`}
                        >
                            {tab.label}
                        </Button>
                    ))}
                </div>

                {/* Tab Content */}
                <div className="mt-4">
                    {activeTab === "addEvent" && <AddEventModal />}
                    {activeTab === "aiEvents" && <SmartEventsGen />}
                    {activeTab === "jsonEvents" && <JsonEventsImporter />}
                    {activeTab === "adminActions" && <AdminActions />}
                    {activeTab === "settings" && <p>Settings content goes here</p>}
                </div>
            </div>
        </div>
    );
}
